import { render, staticRenderFns } from "./TermsKTPersonalThirdPartyKT.vue?vue&type=template&id=3951a219&scoped=true&"
var script = {}
import style0 from "./TermsKTPersonalThirdPartyKT.vue?vue&type=style&index=0&id=3951a219&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951a219",
  null
  
)

export default component.exports